<template>
    <lv-base-column
            ref="column" v-bind="columnBinding">
        <template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
            <link-table-column-checkbox-item
                    :row="row"
                    :edit-row="editRow"
                    :row-index="rowIndex"
                    :col="col"
                    :col-index="colIndex"
                    :fixed-row="fixedRow"
                    v-bind="columnItemBinding"
                    @click.native="lv_clickItem"

                    :size="size"
                    :color="color"
                    :active-icon="activeIcon"
                    :inactive-icon="inactiveIcon"
                    :active-color="activeColor"
                    :inactive-color="inactiveColor"
                    :true-value="trueValue"
                    :false-value="falseValue"
            />
        </template>
    </lv-base-column>
</template>

<script>
    import {ColumnMixin} from "../mixins";
    import LinkRadio from "../../radio/link-radio";
    import LinkTableColumnCheckboxItem from "./link-table-column-checkbox-item";
    import LvBaseColumn from "../../table/lv-base-column";

    export default {
        name: 'link-table-column-checkbox',
        components: {
            LvBaseColumn,
            LinkTableColumnCheckboxItem,
            LinkRadio,
        },
        mixins: [
            ColumnMixin
        ],
        props: {
            width: {default: 80},
            search: {default: false},
            align: {default: 'center'},
            fastRender: {default: false},

            singleSelect: {type: Boolean, default: true},
            disabled: {type: Boolean},
            size: {default: 'small'},
            color: {default: 'primary',},
            activeIcon: {type: String,},
            inactiveIcon: {type: String,},
            activeColor: {type: String,},
            inactiveColor: {type: String},

            trueValue: {default: 'Y'},
            falseValue: {default: 'N'},

            translate: {
                default() {
                    return (val) => {
                        if (val === this.trueValue) return '是'
                        if (val === this.falseValue) return '否'
                        return val
                    }
                },
            },
        },
    };
</script>
